export default {
  "global.eigaland": "Eigaland",
  "global.VIP": "VIP",
  "global.loading": "読み込み中",
  "global.login": "ログイン",
  "global.logout": "ログアウト",
  "global.yes": "はい",
  "global.no": "いいえ",
  "global.do": "する",
  "global.donot": "しない",
  "global.search": "検索",
  "global.update": "更新",
  "global.confirm": "確認",
  "global.create": "作成",
  "global.add": "追加",
  "global.save": "保存",
  "global.edit": "編集",
  "global.cancelRefund": "取消し",
  "global.delete": "削除",
  "global.cancel": "取消",
  "global.detail": "詳細",
  "global.upload": "アップロード",
  "global.download": "ダウンロード",
  "global.approve": "承認",
  "global.allApprove": "全期間承認",
  "global.dateApprove": "日付承認",
  "global.addKitchen": "キッチンプリンター追加",
  "global.control": "操作",
  "global.active": "有効化",
  "global.inactive": "無効化",
  "global.valid": "有効",
  "global.invalid": "無効",
  "global.allValid": "一括有効",
  "global.approveAll": "登録内容を確認し、間違いがないことを確認してください。すべて承認する場合は、「承認」を押してください。",
  "global.all": "すべて",
  "global.allType": "すべてのタイプ",
  "global.none": "なし",
  "global.name": "名前",
  "global.createTime": "作成時間",
  "global.sort": "表示順番",
  "global.permission": "許可",
  "global.state": "ステータス",
  "global.price": "価格",
  "global.price_taxIncluded": "価格（税込）",
  "global.cinema": "劇場",
  "global.cinemaName": "劇場名",
  "global.mobile": "モバイル",
  "global.print": "印刷",
  "global.basicInfo": "基本情報",
  "global.journalLinkageSetting": "仕訳連携設定",
  "global.inventoryTable": "棚卸表",
  "global.uploadInventoryTable": "棚卸表アップロード",
  "global.listCSV": "一覧CSV",
  "global.CSVBatchOperation": "CSV一括操作",
  "global.exportToCSV": "CSVファイル出力",
  "global.printBtn": "プリント",
  "global.createSuccessfully": "作成しました",
  "global.updateSuccessfully": "更新しました",
  "global.deleteSuccessfully": "削除しました",
  "global.approveSuccessful": "承認しました",
  "global.operationSuccessful": "操作成功",
  "global.disappearAfter3s": "3秒後に自動的に閉じます",
  "global.comingSoon": "準備中",
  "global.pageNotFound": "ページが見つかりません",
  "global.goToHomePage": "ホーム画面へ",
  "global.backTo": "戻る",
  "global.needHelps": "ヘルプ",
  "global.Japan": "日本",
  "global.USA": "米国",
  "global.China": "中国",
  "global.UK": "イギリス",
  "global.POS": "POS",
  "global.CMS": "CMS",
  "global.selfCashier": "自動券売機",
  "global.selfCheckout": "自動券売機",
  "global.consumerCashRegister": "コンセセルフレジ",
  "global.scanner": "スキャナー",
  "global.pwa": "オンライン予約",
  "global.online": "オンライン",
  "global.hiddenCMS": "CMS非表示",
  "global.app": "アプリ",
  "global.webCconsole": "CMS",
  "global.bookOnline": "オンライン予約",
  "global.sign": "サイネージ",
  "global.window": "窓口",
  "global.saletaxRate": "消費税率",
  "global.change": "変更",
  "global.today": "今日",
  "global.status": "ステータス",
  "global.notApplicable": "対象外",
  "global.dutyFree": "非課税",
  "global.endDate": "終了日",
  "global.applicableTheater": "適用劇場",
  "global.possible": "可能",
  "global.impossible": "不可",
  "global.repair": "お直り",
  "global.image": "画像",
  "global.inventoryChange": "在庫変更",
  "global.department": "部門",
  "global.salesDepartment": "売上部門",
  "global.selling": "販売中",
  "global.updating": "販売更新",
  "global.stopSelling": "販売停止",
  "global.productSalesList": "物販一覧",
  "global.allDepartments": "部門全て",
  "global.item": "アイテム",
  "global.works": "作品",
  "global.titleOfWork": "作品名",
  "global.unit": "単位",
  "global.unitPrice": "単価",
  "global.quantity": "数量",
  "global.purchase": "買取",
  "global.entrust": "委託",
  "global.option": "オプション",
  "global.type": "種類",
  "global.remarks": "備考",
  "global.example": "例）",
  "global.commercial": "物販",
  "global.productCode": "商品コード",
  "global.dispRelatedSettings": "表示関連設定",
  "global.displaySettings": "表示設定",
  "global.hiddenSetting": "非表示設定",
  "global.getGoods": "入荷",
  "global.sale": "販売",
  "global.refound": "返送",
  "global.discard": "廃棄",
  "global.other": "その他",
  "global.discount": "割引",
  "global.accountsReceivable": "売掛金",
  "global.quota": "定額",
  "global.or": "または",
  "global.total": "合計",
  "global.total2": "総計",
  "global.fee": "手数料",
  "global.circle": "円",
  "global.order": "順番",
  "global.streetAddress": "住所",
  "global.selectAll": "全選択",
  "global.deselectAll": "全選択解除",
  "global.reset": "リセット",
  "global.screen": "スクリーン",
  "global.screenStandard": "スクリーン規格",
  "global.subtitlesDubbing": "字幕 / 吹替",
  "global.versions": "バージョン",
  "global.otherVersions": "その他バージョン",
  "global.btnBackgroundColor": "ボタン背景色",
  "global.btnTextColor": "ボタン文字色",
  "global.displayOrder": "表示順番",
  "global.groupDisplay": "グループ表示",
  "global.email": "メールアドレス",
  "global.username": "ユーザー名",
  "global.password": "パスワード",
  "global.dialog.confirmCinemas": "劇場を確認",
  "global.registration": "登録",
  "global.instant": "即時反映",
  "global.reflect": "予約反映",
  "global.allCinemas": "全ての劇場",
  "global.description": "摘要",
  "global.cannotDelete": "データは削除できません",
  "global.yen.text": "円",
  "global.returnGoods": "返品",
  "global.date": "日時",
  "global.amount": "金額",
  "global.coupon": "クーポン",
  "global.taxRate": "税率",
  "global.close": "閉じる",
  "global.confirm2": "確定",
  "global.settlement": "決済",
  "global.id": "ログID",
  "global.sun": "日",
  "global.mon": "月",
  "global.tue": "火",
  "global.wed": "水",
  "global.thu": "木",
  "global.fri": "金",
  "global.sat": "土",
  "global.week": "週",
  "global.day": "日",
  "global.month": "月",
  "global.year": "年",
  "global.select": "選択",
  "global.noData": "記録なし",
  "global.subtitlesVersion.NONE": "なし",
  "global.subtitlesVersion.SUBTITLE": "字幕",
  "global.subtitlesVersion.DUB": "吹替",
  "global.sort.ascending": "昇順",
  "global.sort.descending": "降順",
  "global.companyName": "会社名",
  "global.subtotal": "小計",
  "global.cost": "料金",
  "global.search.tips": "ENTERで候補一覧を表示",
  "global.uploadPDF": "PDFメニューアップロード",
  "global.getRealData": "当日データ表示",
};
